export const locale = {
  dashboard_origin: "لوحة التحكم",
  menu: "قائمة",
  get_menu_again: "إعادة جلب القائمة",
  loading_error: {
    title: "خطأ في التحميل!",
    message: "حدث خطأ أثناء تحميل البيانات! يرجى المحاولة مرة أخرى",
    text: "إعادة المحاولة",
  },
  copy_right: {
    year: "١٤٤٦",
    text1:
      "جميع الحقوق المادية والمعنوية لهذا النظام محفوظة وتعود إلى شركة الإعلانات",
    text2: "رواد الأعمال المتميزين",
    text3: "سيف أراد، وأي نسخ يخضع للملاحقة القانونية.",
  },
  user: "عزيزي المستخدم",
  hi: "مرحبا",
  exit: "خروج",
  go_to_page: "انتقل إلى الصفحة",
  show: "عرض",
  until: "حتى",
  from: "من",
  page: "صفحة",
  notes: "ملاحظات",
  created_at: "تاريخ الإنشاء",
  registration: "تسجيل",
  edit_contact: "تعديل جهة الاتصال",
  cancel: "إلغاء",
  edit: "تعديل",
  delete: "حذف",
  contact_info: "معلومات الاتصال",
  add_birthday: "إضافة تاريخ الميلاد",
  contacts: "دفاتر الهاتف",
  last_updated_at: "آخر تعديل",
  added_to_contact: "تمت إضافته إلى جهات الاتصال",
  contact_registered: "لم يتم حفظ جهة الاتصال الخاصة بك.",
  transaction: "معاملة",
  write_message: "كتابة رسالة",
  note_title: "عنوان الملاحظة",
  create_note: "إضافة ملاحظة",
  are_you_sure_to_delete: "هل أنت متأكد من الحذف؟",
  last_transaction: "آخر المعاملات",
  your_balance: "رصيدك",
  no_transaction: "لم يتم تسجيل أي معاملة لك بعد!",
  increase_balance: "زيادة الرصيد",
  transaction_list: "قائمة المعاملات",
  withdraw: "سحب الأموال",
  decrease: "سحب الأموال",
  deposit: "إيداع الأموال",
  increase: "إيداع الأموال",
  charge: "شحن المحفظة",
  refund: "استرداد الأموال",
  save: "حفظ",
  reload: "إعادة تحميل القائمة",
  shared: "مشترك",
  list: "قائمة",
  single_add: "إضافة فردية",
  mass_add: "إضافة جماعية",
  excel_add: "إضافة من إكسل",
  added_successfully: "تمت الإضافة بنجاح",
  error_add_phone: "خطأ في إضافة الرقم",
  group: {
    add: "إضافة مجموعة جديدة",
    delete: "حذف المجموعة",
    edit: "تعديل المجموعة",
    first: "يرجى إضافة مجموعة جديدة أولاً.",
  },
  successfully_deleted: "تم الحذف بنجاح",
  notification: {
    text: "إشعارات المستخدم",
    new: "رسالة جديدة",
    messages: "الرسائل",
    events: "الأحداث",
    no_new_message: "لا توجد رسائل جديدة!",
    show_all: "عرض الكل",
    no_new_event: "لا توجد أحداث جديدة!",
    go_to_user: "انتقل إلى المستخدم",
    watched: "شاهدتها",
  },
  locking_for_service: "تبحث عن أي خدمة؟",
  service_name: "أدخل اسم الخدمة المطلوبة...",
  invite: {
    title: "قدم النظام لأصدقائك.",
    gift: "هدية",
    get: "احصل عليها.",
    phone: "أدخل الرقم.",
    invite: "ادعُ!",
    got_it: "فهمت",
    get_gift: "احصل على الهدية",
    success: "تم إرسال دعوتك بنجاح.",
    wrong_number: "يرجى إدخال رقم صحيح.",
  },
  ticker: {
    text: "نحن معك في كل لحظة...",
    help: "للتواصل مع فريق الدعم، سجل تذكرة",
    register: "تسجيل تذكرة",
  },
  package: {
    title: "الباقات النشطة",
    no: "ليس لديك أي باقة نشطة.",
    no_limit: "لوحة غير محدودة",
    day: " يومي",
    other: " أخرى",
    expiration: "انتهاء ",
    expired: "منتهية ",
  },
  Loading: {
    Waiting: "يرجى الانتظار",
    Description: "لحظة من فضلك",
  },
  Questions: {
    Yes: "نعم",
    No: "لا",
  },
  Success: {
    Title: "ناجح",
    defaultActionText: "فهمت",
  },
  Info: {
    Title: "إشعار",
    defaultActionText: "فهمت",
  },
  Warning: {
    Title: "تنبيه",
    defaultActionText: "فهمت",
  },
  Error: {
    Title: "خطأ",
    defaultActionText: "فهمت",
  },
  Wallet: {
    Title: "رصيد غير كافٍ",
    defaultActionText: "فهمت",
  },
  ConnectionLost: {
    Title: "انقطع الإنترنت",
    Subtitle: "يرجى التأكد من اتصالك بالإنترنت",
    Button: "إعادة المحاولة",
  },
  emoji: "إيموجي",
  text_suggest_free: "مستشار النصوص (مجاني)",
  select_campaign: "اختيار حملة",
  short_link: "رابط قصير",
  text_suggest: "مستشار النصوص",
  select_emoji: "اختيار إيموجي",
  default_text: "نص افتراضي",
  emoji_group: {
    "Smileys & Emotion": "الابتسامات والعواطف",
    "People & Body": "الأشخاص والجسم",
    "Animals & Nature": "الحيوانات والطبيعة",
    "Food & Drink": "الطعام والشراب",
    "Travel & Places": "السفر والأماكن",
    Activities: "الأنشطة",
    Objects: "الأشياء",
    Symbols: "الرموز",
    Flags: "الأعلام",
  },
  table: {
    index: "ترتيب",
    title: "العنوان",
    text: "النص",
    select: "اختيار",
    next: "التالي",
    previous: "السابق",
    rows_per_page: "عدد في الصفحة",
    no_data: "لا توجد بيانات للعرض",
    search_placeholder: "بحث",
  },
  modal: {
    success: "نجاح",
  },
  actions: {
    remove: "حذف",
    copyLink: "نسخ الرابط",
    operations: "عمليات",
    edit: "تعديل",
    delete: "حذف",
    show: "عرض",
    accept: "تأكيد",
    reject: "رفض",
    enable: "تفعيل",
    download: "تحميل",
    deactive: "إلغاء التفعيل",
  },

  shortLink: {
    freeShorten: 'قصر روابطك "مجاناً".',
    clickToSelect: "اضغط على الرابط المطلوب لاختياره.",
    create: "إنشاء رابط قصير",
    title: "العنوان",
    titleHint: "يرجى إضافة اسم للرابط القصير.",
    link: "الرابط",
    linkHint: "أدخل الرابط المطلوب.",
    shortenedLink: "الرابط المقصر",
    clickCount: "عدد النقرات",
    selectDomain: "اختيار النطاق",
  },
  pagination: {
    next: "التالي",
    previous: "السابق",
    rowsPerPage: "عدد في الصفحة",
    noData: "لا توجد بيانات للعرض",
    search: "بحث",
  },
  validation: {
    titleRequired: "العنوان مطلوب",
    minLength4: "الحد الأدنى 4 أحرف",
    linkRequired: "الرابط مطلوب",
    mustIncludeHttps: "يجب أن يحتوي على https://",
    invalidLink: "يرجى إدخال رابط صحيح.",
  },
  messages: {
    addedSuccessfully: "تمت الإضافة بنجاح.",
    confirmDeleteShortLink: "تأكيد حذف الرابط القصير؟",
  },
  inputMenu: {
    text: "نص",
    selectUserInfo: "اختيار تفاصيل المستخدم",
  },
  patternDialog: {
    title: "اختيار نمط/حملة",
    change: "تغيير النمط/الحملة",
    createPattern: "تسجيل نمط جديد",
    createCampaign: "تسجيل حملة جديدة",
    tabs: {
      pattern: "اختيار نمط",
      campaign: "اختيار حملة",
    },
    empty: "لم يتم العثور على نمط، سجل نمطاً أولاً.",
    columns: {
      id: "المعرف",
      type: "النوع",
      pattern: "النمط",
      static: "ثابت",
      title: "العنوان",
      content: "النص",
      status: "الحالة",
      rejected: "مرفوض",
      approved: "مقبول",
    },
    pagination: {
      next: "التالي",
      prev: "السابق",
      rowsPerPage: "عدد في الصفحة",
      noData: "لا توجد بيانات للعرض",
      search: "بحث",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "الرسالة المختارة:",
    REQUIRED_INPUTS: "المدخلات المطلوبة:",
    SELECTED_CAMPAIGN: "الحملة المختارة:",
    CAMPAIGN_ID: "المعرف",
    PRE_NAME: "البادئة",
    NAME: "الاسم",
    MIDDLE_NAME: "الاسم الأوسط",
    LAST_NAME: "اسم العائلة",
    POST_NAME: "اللاحقة",
    ALIAS: "الاسم المستعار",
    COMPANY: "الشركة",
    JOB_TITLE: "المنصب الوظيفي",
    PHONE: "رقم الهاتف",
    BIRTHDAY: "تاريخ الميلاد",
    DESCRIPTION: "الوصف",
  },
  CONTACT_GROUP: {
    LIST: "قائمة",
    ADD: "إضافة",
    SEARCH: "بحث",
    INDEX: "ترتيب",
    ID: "المعرف",
    GROUP_NAME: "اسم المجموعة",
    PARENT: "الأصل",
    CREATE: {
      GROUP_NAME: "اسم المجموعة الافتراضي",
      PARENT_CATEGORY: "الفئة الأصلية",
      ADD_GROUP: "إضافة مجموعة",
      SUCCESS: "تم إضافة المجموعة الافتراضية بنجاح.",
      ERROR: "خطأ في إضافة المجموعة الافتراضية!",
      SEARCH: "بحث",
      TITLE: "العنوان",
      SEARCH_IN_TITLE: "بحث في العنوان",
      FROM: "من",
      TO: "إلى",
      BIRTHDAY_FROM: "تاريخ الميلاد من",
      BIRTHDAY_TO: "إلى تاريخ",
      ITEMS_PER_PAGE: "عدد في الصفحة",
      PHONE_COPY: "نسخ الرقم",
      COPY_PHONE: "نسخ الرقم",
      DELETE_CONTACT_GROUP: "حذف جهة الاتصال من المجموعة",
      DELETE_FROM_GROUP_ONLY: "حذف جهة الاتصال من هذه المجموعة فقط",
      DELETE_FROM_ALL_GROUPS: "حذف جهة الاتصال من جميع المجموعات",
      USER: "المستخدم",
      PHOTO: "صورة",
      FULL_NAME: "الاسم الكامل",
      EMAIL: "البريد الإلكتروني",
      PHONE_NUMBER: "رقم الهاتف",
      JOB_TITLE_COMPANY: "المنصب الوظيفي والشركة",
      CREATED_AT: "وقت الإنشاء",
      PHONEBOOK: "دفتر الهاتف",
      ACTIONS: "عمليات",
    },
    TITLE: "العنوان",
    SEARCH_IN_TITLE: "بحث في العنوان",
    FROM: "من",
    TO: "إلى",
    BIRTHDAY_FROM: "تاريخ الميلاد من",
    BIRTHDAY_TO: "إلى تاريخ",
    ITEMS_PER_PAGE: "عدد في الصفحة",
    PHONE_COPY: "نسخ الرقم",
    COPY_PHONE: "نسخ الرقم",
    DELETE_CONTACT_GROUP: "حذف جهة الاتصال من المجموعة",
    DELETE_FROM_GROUP_ONLY: "حذف جهة الاتصال من هذه المجموعة فقط",
    DELETE_FROM_ALL_GROUPS: "حذف جهة الاتصال من جميع المجموعات",
    USER: "المستخدم",
    PHOTO: "صورة",
    FULL_NAME: "الاسم الكامل",
    EMAIL: "البريد الإلكتروني",
    PHONE_NUMBER: "رقم الهاتف",
    JOB_TITLE_COMPANY: "المنصب الوظيفي والشركة",
    CREATED_AT: "وقت الإنشاء",
    PHONEBOOK: "دفتر الهاتف",
    ACTIONS: "عمليات",
  },
  GRADUAL: {
    SEND_GRADUAL: "إرسال تدريجي",
    ALLOWED_HINT: "للإرسال بأعداد أكثر من ٥٠٠ رقم",
    SEND_GRADUAL_OPTION: "إرسال تدريجي",
    AFTER_EVERY: "بعد كل",
    SEND_SMS: "رسالة نصية ترسل؟",
    TIME_INTERVAL: "الفاصل الزمني",
    SMS_PART: "عدد الرسائل",
    SMS_PART_HINT: "أدخل عدد الرسائل في كل دفعة مرسلة.",
    COUNT_ERROR: "عدد الرسائل في كل دفعة لا يمكن أن يكون أقل من ٥٠٠!",
  },
  HISTORY: {
    CREATE_NEW: "إنشاء سجل جديد",
    BACK: "رجوع",
    TITLE: "عنوان السجل",
    STEP: "المرحلة",
    LAST_CALL: "وقت آخر مكالمة",
    DISCUSSIONS: "المناقشات المنفذة",
    REMIND_DATE: "وقت التذكير",
    FOLLOWUP: "بنود المتابعة في المكالمة التالية",
    SAVE_HISTORY: "حفظ السجل",
    INDEX: "ترتيب",
    SAVED_BY: "المسجل",
    ACTION: "إدارة",
    MORE_INFO: "معلومات إضافية عن",
    CREATE_ERROR: "خطأ في إضافة سجل العميل!",
  },
  FORMS: {
    SourceNumber: "رقم المصدر",
    DestinationPhone: "رقم الوجهة",
    Add: "إضافة",
    SEND_TO_SELECTED_NUMBERS: "إرسال إلى الأرقام المختارة",
    CHANGE_PATTERN_CAMPAIGN: "تغيير النمط/الحملة",
    SendTime: "وقت الإرسال",
    SELECTED_MESSAGE: "الرسالة المختارة",
    REQUIRED_INPUTS: "المدخلات المطلوبة",
    SELECTED: "مختار",
    ID: "المعرف",
    SEND: "إرسال",
    DATE_REQUIRED: "اختيار التاريخ مطلوب.",
    TIME_INTERVAL: "الفاصل الزمني",
    TIME_INTERVAL_FROM_PREVIOUS: "الفاصل الزمني من الرسالة السابقة",
    Title: "العنوان",
    LINK: "رابط",
    LINK_HINT: "أي",
    LINK_PLACEHOLDER: "مثال:[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "سيتم استبدال الرابط بعد التقصير بطول ١٤ حرفاً (example.ex/any) داخل النص وسيتم إرسال رابط مخصص لكل رسالة.",
    Text: "نص",
    MUST_INCLUDE_PATTERN: "يجب أن يحتوي على {pattern}",
    INVALID_LINK: "أدخل رابطاً صحيحاً",
  },
  ERRORS: {
    VpnDetectedTitle: "أطفئ الـ VPN",
    VpnDetectedSubtitle:
      "هذا يساعد النظام على العمل بشكل أفضل ويمنحك تجربة أحسن.",
    PhoneIsNotValid: "رقم الهاتف غير صالح",
    MaxPhoneLimit: "لا يمكنك إضافة أكثر من 50000 رقم.",
    NoSelectedLineNumber: "لم يتم اختيار خط.",
    INVALID_TIMER: "أدخل وقتاً صحيحاً",
    PhoneIsNotValid: "رقم الهاتف غير صالح",
    MaxPhoneLimit: "لا يمكنك إضافة أكثر من ٥٠٠٠٠ رقم.",
    NoSelectedLineNumber: "لم يتم اختيار خط.",
    INVALID_TIMER: "أدخل وقتاً صحيحاً",
    NoAccess: "لا تملك صلاحية",
    PleaseBuyAPlane: "يرجى شراء خطة",
    NoAccountCharge: "رصيد الحساب غير كافٍ",
    PleaseChargeYourAccount: "يرجى شحن حسابك",
    Unauthorized: "غير مصرح: يرجى تسجيل الدخول مرة أخرى",
    ServerError: "حدث خطأ في الخادم، يرجى المحاولة لاحقاً",
    NetworkError: "خطأ في الشبكة: يرجى التحقق من اتصالك بالإنترنت",
    InvalidInput: "المدخل غير صالح",
    SessionExpired: "انتهت جلستك، يرجى تسجيل الدخول مرة أخرى",
    TokenInvalid: "التوكن غير صالح",
    VpnDetected: "الـ VPN مفعل، يرجى إطفاؤه",
    RequestTimeout: "انتهى طلبك، يرجى المحاولة مرة أخرى",
    DuplicateEntry: "هذا البند مسجل مسبقاً",
  },

  BUTTONS: {
    DELETE_NUMBERS: "حذف الأرقام",
    ADD_BULK: "إضافة جماعية",
    FROM_FILE: "من ملف",
    More: "المزيد",
    BuyAPlane: "شراء خطة",
    AccountCharge: "شحن الحساب",
    OK: "تأكيد",
    Close: "إغلاق",
    Cancel: "إلغاء",
    Retry: "إعادة المحاولة",
    Login: "دخول",
    Logout: "خروج",
    Save: "حفظ",
    Submit: "إرسال",
  },
  GENERAL: {
    row: "ترتيب",
    id: "المعرف",
    back: "رجوع",
    manage: "إدارة",
    SENDING: "جاري الإرسال",
    RELOAD: "إعادة التحميل",
    PRINT: "طباعة",
    DELETE: "حذف",
    SUBMIT: "إرسال",
    SUCCESSFULLY_ADDED: "تمت الإضافة بنجاح",
    RELOAD: "إعادة التحميل",
    CANCEL: "إلغاء",
    SUCCESSFULLY_DOWNLOADED: "تم التحميل بنجاح",
    Loading: "جاري التحميل...",
    NoData: "لم يتم العثور على بيانات",
    Welcome: "أهلاً وسهلاً",
    Profile: "الملف الشخصي",
    Settings: "الإعدادات",
    Wallet: "المحفظة",
    Dashboard: "لوحة التحكم",
  },

  NOTICES: {
    Attention: "انتبه",
    MinimumSendWarning:
      'عند إرسال الرسائل برقم "إخباري" يجب أن يكون الحد الأدنى {{number}} رقم.',
  },
  contactsTags: {
    select_group: "اختيار مجموعة",
    create_group: "إنشاء مجموعة",
    search: "بحث",
    add_group: "إضافة مجموعة",
    enter_group_name: "أدخل الاسم المطلوب",
    group_name: "اسم المجموعة",
    cancel: "إلغاء",
    edit: "تعديل",
    save: "حفظ",
    loading_categories: "جاري تحميل الفئات...",
    select_group_and_subgroup: "اختيار مجموعة ومجموعة فرعية",
    add_group_with_subgroups: "إضافة المجموعة مع المجموعات الفرعية",
    add_group_only: "إضافة المجموعة المختارة فقط",
    duplicate_name_error: "الاسم مكرر",
    added_successfully: "تمت الإضافة بنجاح.",
    confirm_delete_group: "تأكيد حذف المجموعة؟",
    deleted_successfully: "تم الحذف بنجاح",
    edited_successfully: "تم التعديل بنجاح",
    group_added_successfully: "تم إضافة المجموعات المختارة بنجاح.",
    error_creating_group: "خطأ في إضافة المجموعة الافتراضية",
    create_default_group: "إنشاء مجموعة افتراضية",
    select_default_group: "اختيار مجموعة افتراضية",
    add_custom_group: "إضافة مجموعة باسم مخصص",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "إضافة رقم هاتف",
    ADD: "إضافة",
    SHARE_ACCESS:
      "باختيار أي من الخيارات أدناه، شارك الصلاحية المطلوبة مع الآخرين.",
    SELECT_ACCESS: "اختيار صلاحية دفتر الهاتف",
    DELETE: "حذف",
    EDIT: "تعديل",
    SEND: "إرسال",
    PERSONS_WITH_ACCESS: "الأشخاص الذين لديهم صلاحية",
    REMOVE_ACCESS: "إزالة الصلاحية",
    RETURN: "رجوع",
    SAVE_CHANGES: "حفظ التغييرات",
    SHARE_CONTACT_BOOK: "مشاركة دفتر الهاتف",
    PHONE_VALIDATION: "أدخل رقم هاتف صحيح",
    SUCCESS_SHARE: "تم مشاركة دفتر الهاتف بنجاح.",
    ERROR_SHARE: "خطأ في مشاركة دفتر الهاتف!",
    PHONE_DUPLICATE: "الرقم مدخل مسبقاً!",
    CHANGES_SAVED: "تم حفظ التغييرات بنجاح.",
    ERROR_SAVING_CHANGES: "خطأ في حفظ التغييرات!",
  },
  CONTACT_SEARCH: {
    SEARCH: "بحث",
    ADD_NUMBER: "أضف رقم",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "عدد في كل صفحة",
    FROM: "من",
    TO: "إلى",
    TOTAL: "الإجمالي",
  },
  SUCCESS: {
    DELETED: "تم الحذف بنجاح",
    SUCCESS: "نجاح",
  },
  CONFIRM: {
    DELETE_BULK: "حذف الأرقام غير المحفوظة؟",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "انسخ أرقامك ثم اضغط",
    COPY_LINK: "نسخ الرابط",
    COPY_NUMBER: "نسخ الرقم",
    SEE_PROFILE: "عرض الملف الشخصي",
  },
  CONTACT_EDIT: {
    EDIT: "تعديل",
    DELETE: "حذف",
  },
  CONTACT_MENU: {
    SHARE: "مشاركة",
    PRINT: "طباعة",
    EXCEL_EXPORT: "تصدير إكسل",
    DELETE: "حذف",
    SUCCESS_DELETE: "تم الحذف بنجاح.",
    ERROR_DELETE: "خطأ في حذف جهات الاتصال!",
  },
  CONTACTS: {
    PREFIX: "البادئة",
    NAME: "الاسم",
    MIDDLENAME: "الاسم الأوسط",
    LASTNAME: "اسم العائلة",
    POSTFIX: "اللاحقة",
    ALIAS: "الاسم المستعار",
    COMPANY: "الشركة",
    JOBTITLE: "المنصب الوظيفي",
    PHONE: "رقم الهاتف",
    PHONE_PLACEHOLDER: "مثل: 8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "إضافة بريد إلكتروني",
    EMAIL: "البريد الإلكتروني",
    ADD_ADDRESS: "إضافة عنوان",
    ADDRESS: "العنوان",
    PROVINCE: "المحافظة",
    CITY: "المدينة",
    POSTALCODE: "الرمز البريدي",
    YEAR_OPTIONAL: "السنة (اختياري)",
    MONTH: "الشهر",
    DAY: "اليوم",
    ADD_BIRTHDAY: "إضافة تاريخ الميلاد",
    ADD_WEBSITE: "إضافة موقع إلكتروني",
    WEBSITE: "الموقع الإلكتروني",
    ADD_DATE: "إضافة تاريخ",
    DATE: "التاريخ",
    CUSTOM_FIELD: "حقل مخصص",
    ADD_CUSTOM_FIELD: "إضافة حقل مخصص",
    NOTE: "الملاحظات",
    ADD_NOTE: "إضافة ملاحظة",
    HOME: "المنزل",
    WORK: "مكان العمل",
    OTHER: "أخرى",
    PROFILE: "الملف الشخصي",
    BLOG: "المدونة",
    HOMEPAGE: "الصفحة الرئيسية",
    TITLE: "العنوان",
    BIRTHDAY_ERROR: "أدخل التاريخ بشكل صحيح",
    YEAR_ERROR: "4 أرقام",
    EMAIL_ERROR: "أدخل البريد الإلكتروني بشكل صحيح",
    WEBSITE_ERROR: "أدخل الرابط بشكل صحيح (website.com)",
    PHONE_ERROR: "أدخل رقم الهاتف بشكل صحيح",
    ADD_HISTORY: "إضافة سجل",
    HISTORY_LIST: "قائمة السجلات",
    EDIT_CONTACT: "تعديل جهة الاتصال",
    SHOW_CONTACT: "عرض جهة الاتصال",
  },
  MONTHS: {
    FARVARDIN: "فروردين",
    ORDIBEHESHT: "أورديبهشت",
    KHORDAD: "خرداد",
    TIR: "تير",
    MORDAD: "مرداد",
    SHAHRIVAR: "شهريور",
    MEHR: "مهر",
    ABAN: "آبان",
    AZAR: "آذر",
    DEY: "دي",
    BAHMAN: "بهمن",
    ESFAND: "إسفند",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "تحميل واستخدام ملف إكسل عينة",
    UPLOAD_TITLE: "رفع الملف",
    DRAG_DROP_TEXT_PART1: "اسحب وأفلت للرفع أو",
    DRAG_DROP_TEXT_PART2: "هنا",
    DRAG_DROP_TEXT_PART3: "اضغط",
    FILE_INPUT_LABEL: "رفع ملف إكسل",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "تم نسخ الرابط بنجاح!",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "خطأ في نسخ الرابط.",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "اختيار نمط/حملة",
    BUTTON_EDIT_TEXT: "تغيير النمط/الحملة",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "تسجيل نمط جديد",
    REGISTER_NEW_CAMPAIGN: "تسجيل حملة جديدة",
    CREATE_NEW_HISTORY: "إنشاء سجل جديد",
    SAVE_HISTORY: "حفظ السجل",
    SELECT_GROUP: "اختيار مجموعة",
    CREATE_GROUP: "إنشاء مجموعة",
    ADD_GROUP: "إضافة مجموعة",
    SAVE: "حفظ",
    CREATE_GROUP_SINGULAR: "إنشاء مجموعة",
    ADD: "إضافة",
    SEND: "إرسال",
    EDIT_PERMISSIONS: "تعديل",
    GO_BACK: "رجوع",
    SAVE_CHANGES: "حفظ التغييرات",
    GUIDE: "دليل",
    START: "بدء",
    EDIT: "تعديل",
    CANCEL: "إلغاء",
    AUTO_REFRESH: "تحديث تلقائي",
    AUTO_REFRESH_SETTINGS: "إعدادات التحديث التلقائي",
    BACK: "رجوع",
  },
  TABS: {
    SELECT_PATTERN: "اختيار نمط",
    SELECT_CAMPAIGN: "اختيار حملة",
    LIST: "قائمة",
    ADD: "إضافة",
    ADD_CUSTOM_GROUP: "إضافة مجموعة باسم مخصص",
    SELECT_DEFAULT_GROUP: "اختيار مجموعة افتراضية",
  },
  NO_DATA: {
    NO_PATTERN: "لم يتم العثور على نمط، سجل نمطاً أولاً.",
  },
  TABLE: {
    ID: "المعرف",
    TYPE: "النوع",
    PATTERN: "النمط",
    STATIC: "ثابت",
    TITLE: "العنوان",
    TEXT: "النص",
    STATUS: "الحالة",
    REJECTED: "مرفوض",
    ACCEPTED: "مقبول",
    NEXT_BUTTON: "التالي",
    PREVIOUS_BUTTON: "السابق",
    ROWS_PER_PAGE_TEXT: "عدد في الصفحة",
    NO_DATA_TEXT: "لا توجد بيانات للعرض",
    PLACEHOLDER_SEARCH: "بحث",
    MORE_INFO_ABOUT_ITEM: "معلومات إضافية عن {name}",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "نص",
    SELECT_USER_INFO: "اختيار تفاصيل المستخدم",
  },
  TABLE_CONTROLS: {
    COUNT: "العدد",
    SEARCH: "بحث",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "اسم المجموعة الافتراضي",
    PARENT_CATEGORY: "الفئة الأصلية",
    HISTORY_TITLE: "عنوان السجل",
    STEP: "المرحلة",
    LAST_CALL_TIME: "وقت آخر مكالمة",
    NEGOTIATIONS: "المناقشات المنفذة",
    REMINDER_TIME: "وقت التذكير",
    FOLLOW_UP_ITEMS: "بنود المتابعة في المكالمة التالية",
    GROUP_NAME: "اسم المجموعة",
    SEARCH: "بحث",
    TITLE: "العنوان",
    SEARCH_IN_TITLE: "بحث في العنوان",
    FROM: "من",
    TO: "إلى",
    BIRTHDAY_FROM: "تاريخ الميلاد من",
    BIRTHDAY_TO: "إلى تاريخ",
    COUNT: "العدد",
    ADD_PHONE_NUMBER: "إضافة رقم هاتف",
  },
  TOAST: {
    Success: "تمت العملية بنجاح",
    Error: "حدث خطأ",
    Warning: "تحذير: يرجى التحقق من المدخلات",
    AUTO_REFRESH_STARTED: "بدأ التحديث التلقائي.",
    DEFAULT_GROUP_SUCCESS: "تم إضافة المجموعة الافتراضية بنجاح.",
    DEFAULT_GROUP_ERROR: "خطأ في إضافة المجموعة الافتراضية!",
    ADD_HISTORY_ERROR: "خطأ في إضافة سجل العميل!",
    DUPLICATE_NAME: "الاسم مكرر",
    TAG_ADDED_SUCCESS: "تم إضافة الوسم بنجاح.",
    TAG_DELETED_SUCCESS: "تم حذف الوسم بنجاح.",
    TAG_EDITED_SUCCESS: "تم تعديل الوسم بنجاح.",
    GROUPS_ADDED_SUCCESS: "تم إضافة المجموعات المختارة بنجاح.",
    ADD_GROUP_ERROR: "خطأ في إضافة المجموعة الافتراضية!",
    PHONE_COPIED_SUCCESS: "تم نسخ رقم الهاتف.",
    SUCCESSFULLY_DELETED: "تم الحذف بنجاح",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK:
      "خطأ في حذف جهة الاتصال من دفتر الهاتف!",
    SHARE_SUCCESS: "تم مشاركة دفتر الهاتف بنجاح.",
    SHARE_ERROR: "خطأ في مشاركة دفتر الهاتف!",
    NUMBER_ALREADY_ADDED: "الرقم مدخل مسبقاً!",
    CHANGES_SAVED_SUCCESS: "تم حفظ التغييرات بنجاح.",
    CHANGES_SAVE_ERROR: "خطأ في حفظ التغييرات!",
  },
  HEADERS: {
    GRADUAL_SEND: "إرسال تدريجي",
    GRADUAL_SEND_HINT: "(للإرسال بأعداد أكثر من ٥٠٠ رقم)",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "إرسال تدريجي",
    DELETE: "حذف",
    EDIT: "تعديل",
    ADD: "إضافة",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION: "بعد كل {time} كم رسالة ترسل؟",
  },
  LABELS: {
    TIME_INTERVAL: "الفاصل الزمني",
    MESSAGE_COUNT: "عدد الرسائل",
  },
  TIME_TYPES: {
    MINUTE: "دقيقة",
    HOUR: "ساعة",
    DAY: "يوم",
    WEEK: "أسبوع",
    SECOND: "ثانية",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "أدخل عدد الرسائل في كل دفعة مرسلة.",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT:
      "عدد الرسائل في كل دفعة لا يمكن أن يكون أقل من ٥٠٠!",
  },
  TABLE_HEADERS: {
    ROW: "ترتيب",
    TITLE: "العنوان",
    STEP: "المرحلة",
    REMINDER_TIME: "وقت التذكير",
    LAST_CALL_TIME: "وقت آخر مكالمة",
    RECORDER: "المسجل",
    MANAGEMENT: "إدارة",
    ID: "المعرف",
    GROUP_NAME: "اسم المجموعة",
    PARENT: "الأصل",
    CREATED_AT: "إنشاء",
    IMAGE: "صورة",
    FULL_NAME: "الاسم الكامل",
    EMAIL: "البريد الإلكتروني",
    PHONE_NUMBER: "رقم الهاتف",
    JOB_COMPANY: "المنصب الوظيفي والشركة",
    CREATION_TIME: "وقت الإنشاء",
    PHONEBOOK: "دفتر الهاتف",
    ACTIONS: "عمليات",
    USER: "المستخدم",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "رقم المصدر",
  },
  MODAL: {
    INFO_TITLE: "انتبه.",
    INFO_MESSAGE_NEWS_NUMBER:
      'عند إرسال الرسائل برقم "{number}" يجب أن يكون الحد الأدنى ١٠٠٠ رقم.',
    CONFIRM_DELETE_GROUP: "تأكيد حذف المجموعة؟",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "إرسال إخباري",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "دليل النظام",
    ERROR: "خطأ",
    WARNING: "تحذير",
    SUCCESS: "نجاح",
    CONFIRM: "تأكيد",
    SELECT_GROUP: "اختيار مجموعة",
    CREATE_NEW_GROUP: "إنشاء مجموعة جديدة",
    SELECT_GROUP_SUBGROUP: "اختيار مجموعة ومجموعة فرعية",
    CREATE_DEFAULT_GROUP: "إنشاء مجموعة افتراضية",
    DELETE_CONTACT_FROM_GROUP: "حذف جهة الاتصال من المجموعة",
    DELETE_CONTACT: "حذف جهة الاتصال",
    SHARE_PHONEBOOK: "مشاركة دفتر الهاتف",
    SYSTEM_GUIDE: "دليل نظام ترمينال الإعلانات",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "أدخل الاسم المطلوب",
    SELECT_PERMISSIONS: "اختيار صلاحية دفتر الهاتف {name}:",
    PEOPLE_WITH_ACCESS: "الأشخاص الذين لديهم صلاحية",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "جاري تحميل الفئات...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "إضافة المجموعة مع المجموعات الفرعية",
    SELECTED_GROUP_ONLY: "إضافة المجموعة المختارة فقط",
    DELETE_FROM_THIS_GROUP_ONLY: "حذف جهة الاتصال من هذه المجموعة فقط",
    DELETE_FROM_ALL_GROUPS: "حذف جهة الاتصال من جميع المجموعات",
  },
  FILTER_LABELS: {
    ADDRESS: "العنوان",
    EMAIL: "البريد الإلكتروني",
    WEBSITE: "الموقع الإلكتروني",
    CUSTOM_FIELD: "حقل مخصص",
    DATE: "التاريخ",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION:
      "باختيار أي من الخيارات أدناه، شارك الصلاحية المطلوبة مع الآخرين.",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "أدخل رقم هاتف صحيح",
  },
  LIST_ITEM_TITLES: {
    DELETE: "حذف",
    EDIT: "تعديل",
    ADD: "إضافة",
    REMOVE_ACCESS: "إزالة الصلاحية",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "اسم الحملة",
    TEXT: "النص",
    MESSAGE: "الرسالة",
    FOR: "لـ",
    SELECT_CAMPAIGN: "اختيار حملة",
    CLICK_ROW: "اضغط على الصف المطلوب.",
    NEW: "جديد",
    SUBMIT_CAMPAIGN: "تسجيل الحملة",
    TIME: "الساعة",
    MESSAGE_COUNT: "عدد الرسائل",
    PAGE_COUNT: "إجمالي الرسائل (صفحة)",
    PAGE: "صفحة",
    CANCEL_TEXT: "إلغاء11",
    TRACKABLE_LINK: "رابط قابل للتتبع",
    WARNING_TEXT: "يرجى تصحيح نصوص الحملة المختارة!",
    WARNING_TITLE: "يرجى تصحيح عناوين الحملة المختارة!",
    WARNING_GAP: "يرجى تصحيح الفواصل الزمنية للحملة المختارة!",
    WARNING_OPERATOR: "يرجى تصحيح المشغلين للحملة المختارة!",
    MAX_ITEMS_ERROR: "الحد الأقصى 10 عناصر يمكن إضافتها.",
  },
  ADS: {
    LIVE_SMS: "إرسال رسائل حية",
    BUY_JOB_DB: "شراء قاعدة بيانات الوظائف",
    SMART_LADDER: "سلم ذكي لإعلان ديوار",
    JOB_SMS: "إرسال رسائل إلى الوظائف",
    WEB_DESIGN: "طلب تصميم موقع",
    SEO: "طلب تحسين محركات البحث",
    MAP_SMS: "إرسال رسائل من الخريطة",
    GRADUAL_LADDER: "سلم تدريجي لإعلان ديوار",
    SEO_ALT: "طلب تحسين محركات البحث",
    SITE_SUPPORT: "إدارة ودعم الموقع",
    CITY_SMS: "إرسال رسائل إلى المدينة والمحافظة",
    AUTO_CHAT: "دردشة آلية في ديوار",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "التواصل عبر واتساب",
    TICKET_SUPPORT: "تسجيل تذكرة",
  },
  INCREASE: {
    PAN: "رقم البطاقة",
    CVV2: "CVV2",
    MONTH: "الشهر",
    YEAR: "السنة",
    PIN2: "الرمز الثاني",
    GET_OTP: "الحصول على الرمز الثاني",
    PAY: "دفع",
    INVALID_PAN: "رقم البطاقة غير صحيح",
    INVALID_CVV2: "رمز CVV2 غير صحيح",
  },
  WALLET: {
    CustomCharge: "شحن المحفظة",
    withdrawTitle: "سحب من المحفظة",
    transactionListTooltip: "قائمة معاملاتك",
    reloadTooltip: "إعادة التحميل",
    withdrawTooltip: "سحب من المحفظة",
    AmountLabel: "الائتمان ",
    SelectAmount: "اختيار المبلغ",
    Amount: "المبلغ",
    Currency: "ريال",
    GateWay: "بوابة الدفع",
    noGateWay: "لم يتم العثور على بوابة",
    Pay: "دفع",
    PriceNotInRange: "المبلغ يجب أن يكون بين {min} و {max}.",
    ErrorOnRedirectToGateWay: "خطأ في التحويل إلى بوابة الدفع",
    ErrorGeneral: "خطأ",
    MinAmountError: "المبلغ المدخل أقل من الحد الأدنى المسموح.",
    MinBazarAmountError: "المبلغ لا يمكن أن يكون أقل من ١٠ آلاف تومان!",
    BazarSuccessInfo: "في حال الدفع الناجح، يلزم 1 إلى 3 دقائق لشحن محفظتك.",
    withdrawableBalance: "الرصيد القابل للسحب",
    withdrawFee: "رسوم السحب من الحساب: ٥٠,٠٠٠ ريال!",
    selectAccount: "اختيار الحساب",
    addAccount: "إضافة حساب",
    submitWithdraw: "تسجيل السحب",
    accountRequiredInfo: "إدخال جميع المعلومات مطلوب.",
    ownerName: "اسم صاحب الحساب",
    ownerLastName: "اسم العائلة",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    cardNumber: "رقم البطاقة",
    sheba: "رقم الشيبا",
    onlyPersian: "مسموح فقط بالحروف الفارسية!",
    cardNumberLength: "عدد أرقام البطاقة يجب أن يكون 16 رقماً!",
    shebaLength: "عدد أرقام الشيبا يجب أن يكون 24 رقماً!",
  },
  USER_PICKER: {
    SELECT_USER: "اختيار مستخدم",
    SELECT_USERS: "اختيار مستخدمين",
    SEARCH: "بحث",
    PERSON: "شخص طبيعي",
    COMPANY: "شخص معنوي",
    ID: "المعرف",
    NAME: "الاسم",
    LASTNAME: "اسم العائلة",
    USERNAME: "اسم المستخدم",
    PHONE: "رقم الهاتف",
    TYPE: "نوع المستخدم",
  },
  NEWS: {
    TITLE: "أخبار مسج لاند",
    VIEW_BUTTON: "عرض",
    NO_NEWS: "لا توجد أخبار جديدة.",
    FETCH_ERROR: "خطأ في جلب الأخبار!",
  },
  MENUS: {
    CONTACT_LIST: "قائمة الاتصالات",
    FINDPREFIX: "بحث البادئة",
    // الأنظمة
    TICKET_REGISTRATION: "تسجيل تذكرة",
    AD_TERMINAL_SYSTEM: "نظام ترمينال الإعلانات الكبير",
    WALLET_TRANSACTIONS: "معاملات المحفظة",
    DYNAMIC_QR_SYSTEM: "نظام إنشاء QR ديناميكي",
    DIVAR_AD_SYSTEM: "نظام إدراج وإدارة إعلان ديوار",
    GRAPHIC_DESIGN_SYSTEM: "نظام طلب تصميم غرافيكي، طباعة",
    DIGITAL_MARKETING_SYSTEM: "نظام إدارة التسويق الرقمي",
    BULK_SMS_SYSTEM: "نظام إرسال رسائل جماعية",
    BUSINESS_INFO_SYSTEM: "نظام قاعدة بيانات المهن في البلاد",
    AD_MANAGEMENT_SYSTEM: "نظام إدارة الإعلانات",
    GRAPHIC_VIDEO_SERVICES: "نظام خدمات التصميم الغرافيكي والفيديو",
    // أدوات QR
    QR_TOOL: "أداة QR",
    CREATE_DYNAMIC_QR: "إنشاء QR ديناميكي",
    QR_MANAGEMENT: "إدارة QR",
    QR_MONITORING: "مراقبة QR",
    MY_QR_LIST: "قائمة QR الخاصة بي",
    PHYSICAL_NFC_ORDERS: "طلبات البطاقات الفيزيائية و NFC",
    BULK_QR_GENERATION: "إنشاء QR جماعي",
    IMAGE_CREATION_TOKEN: "توكن إنشاء الصور",
    QR_SMS: "QR رسالة",
    QR_LINK: "QR رابط",
    QR_TEXT: "QR نص",
    QR_LOCATION: "QR موقع / مكان",
    QR_EMAIL: "QR بريد إلكتروني",
    QR_CALL: "QR اتصال",
    QR_WIFI: "QR واي فاي",
    VISIT_STATISTICS: "إحصائيات الزيارة",
    // إدارة الإعلانات
    AD_MONITORING: "مراقبة الإعلانات",
    DIVAR_NEWS: "أحدث ديوار",
    REAL_ESTATE_AD_SUBMISSION: "إرسال إعلان لوحة العقارات",
    AUTO_AD_RENEWAL: "تجديد الإعلانات تلقائياً",
    GRADUAL_AD_SUBMISSION: "إرسال إعلان تدريجي",
    SMART_AD_SUBMISSION: "إرسال إعلان ذكي",
    DEFAULT_AD_REGISTRATION: "تسجيل إعلان افتراضي",
    AD_ANALYZER: "محلل زيارة الإعلان",
    ADD_AD_PHOTO: "إضافة صورة إعلان",
    SMART_LADDER: "سلم ذكي",
    GRADUAL_LADDER: "سلم تدريجي",
    ADS_LIST: "قائمة الإعلانات",
    AD_REPORTS: "تقارير الإعلان",
    SCHEDULED_AD_SUBMISSION: "إرسال إعلان مجدول",
    SCHEDULED_AD_LIST: "قائمة الإعلانات المجدولة",
    PERSONAL_AD_SUBMISSION: "إرسال إعلان شخصي",
    TARGET_TOOLS: "أدوات مستهدفة",
    SMART_LIST: "قائمة ذكية/تدريجية",
    // الرسائل
    SEND_TO_CUSTOMER_CLUB: "إرسال إلى نادي العملاء",
    BULK_SMS: "إرسال رسائل جماعية",
    LIVE_SMS: "إرسال رسائل حية (قديم)",
    SEND_TO_BUSINESSES: "إرسال إلى المهن في البلاد",
    SMS_BY_MAP: "إرسال رسائل من الخريطة",
    CITY_PROVINCE_SMS: "إرسال مدينة ومحافظة",
    RECEIVED_SMS_LIST: "قائمة الرسائل المستلمة",
    SMS_TEXT_CONSULTANT: "مراقب مستشار نصوص الرسائل",
    DEFAULT_TEXT_CONSULTATION: "نص افتراضي + استشارة",
    ADMIN_SMS_SUBMISSIONS: "إرسالات الأدمن",
    PENDING_SMS: "رسائل في انتظار التأكيد",
    ADMIN_RECEIVED_REPORT: "تقرير استلام الأدمن",
    PATTERN: "نمط/قالب",
    SMS_REPORTS: "تقارير الإرسال",
    DEDICATED_LINE_REQUESTS: "طلبات الخط المخصص",
    PHONEBOOK: "دفتر الهاتف",
    SMS_TARIFFS: "تعرفة الرسائل",
    LINE_CATEGORIES: "تصنيف الخطوط",
    TARIFF_COEFFICIENTS: "معاملات التعرفة",
    SEND_ADMIN_SMS: "إرسال رسالة أدمن",
    // الأرقام وجهات الاتصال
    ADD_NEW_NUMBER: "إضافة رقم جديد",
    NUMBERS: "الأرقام",
    USER_NUMBERS: "أرقام المستخدمين",
    REGISTER_USER_NUMBER: "تسجيل رقم للمستخدم",
    NUMBER_LIST: "قائمة أرقامي",
    CREATE_NUMBER_TARIFF: "إنشاء تعرفة الأرقام",
    NUMBER_TARIFF_LIST: "قائمة تعرفة الأرقام",
    OTHER_TARIFF_LIST: "قائمة تعرفات أخرى",
    // الإدارة المالية
    WALLET: "محفظة جديدة",
    TRANSFER_REQUESTS: "طلبات السحب",
    DIVAR_PAYMENTS: "دفعات ديوار",
    AUTO_PAYMENT: "دفع تلقائي",
    PAYMENTS: "الدفعات",
    PAYMENT_GATEWAY: "بوابة الدفع",
    BUY_CHARGE: "شراء شحن",
    // إدارة العملاء والمستخدمين
    CUSTOMERS: "العملاء",
    CRM_CUSTOMERS: "CRM العملاء",
    CONTACT_LIST: "مساعد الاتصال (شكر على الاتصال)",
    USERS: "قائمة المستخدمين",
    USER_REQUESTS: "طلبات المستخدمين",
    PROFILE: "الملف الشخصي",
    USER_HISTORY_NOTIFICATIONS: "إشعارات سجل المستخدمين",
    // التصميم والمحتوى
    WEBSITE_DESIGN_ORDER: "طلب تصميم موقع",
    SEO_ORDER: "طلب تحسين محركات البحث",
    BUY_INFO_DATABASE: "شراء قاعدة بيانات",
    BUY_MOBILE_DATABASE: "شراء قاعدة أرقام الهواتف",
    PURCHASED_ARCHIVES: "الأرشيفات المشتراة",
    FAVORITE_ARCHIVES: "الأرشيفات المفضلة",
    UPLOAD_CENTER: "مركز الرفع",
    CONTENT: "المحتوى",
    // الإدارة والإعدادات
    MONITORING: "مراقبة",
    MANAGEMENT: "إدارة",
    SETTINGS: "الإعدادات",
    CATEGORIES: "التصنيفات",
    DOMAINS: "النطاقات",
    REMINDERS: "التذكيرات",
    AUTOMATIC_CREATION: "إنشاء تلقائي",
    PERMISSIONS: "الصلاحيات",
    ROLES: "الأدوار",
    MENUS: "القوائم",
    CORE_MANAGEMENT: "إدارة الأساس",
    WORK_REPORTS: "إدارة تقارير العمل",
    WORK_REPORT_CREATE: "تقرير عمل",
    DEPARTMENTS: "الأقسام",
    DISCOUNTS: "الخصومات",
    NOTIFICATIONS: "الإشعارات",
    ADMIN_NOTIFICATIONS: "إشعارات الأدمن",
    TICKET_MANAGEMENT: "إدارة التذاكر",
    USER_GUIDE: "دليل المستخدم",
    CAMPAIGN: "الحملة",
    MESSAGE_CATEGORIES: "تصنيف الرسائل",
    REGISTERED_INFO_LIST: "قائمة المعلومات المسجلة",
    TARIFFS: "التعرفات",
    INFORMATION_REGISTRATION: "تسجيل المعلومات",
    UNCREATED_CARDS: "البطاقات غير المنشأة",
    MODELS_LIST: "قائمة النماذج",
    CREATE_DEFAULT_PRODUCT: "إنشاء منتج افتراضي",
    EXCEL_FILES: "ملفات إكسل",
    AUTO_CHATS: "دردشة ذكية",
    AUTO_CHAT: "دردشة آلية",
    // أخرى
    MY_FILES: "ملفاتي",
    CONSULTANTS: "المستشارون",
    ADD_DIVAR_NEWS: "إضافة أحدث ديوار",
    BUY_PANEL: "شراء لوحة",
    PANELS: "اللوحات",
    CALL_MONITORING: "مراقبة الاتصال",
    INFO_REVIEW: "مراجعة المعلومات",
    MESSAGES: "الرسائل",
    PERSONNEL: "الموظفون",
    //qr
    QR_TOOL: "أداة QR",
    CREATE_DYNAMIC_QR: "إنشاء QR ديناميكي",
    QR_MANAGEMENT: "إدارة QR",
    QR_MONITORING: "مراقبة QR",
    MY_QR_LIST: "قائمة QR الخاصة بي",
    PHYSICAL_NFC_ORDERS: "طلبات البطاقات الفيزيائية و NFC",
    BULK_QR_GENERATION: "إنشاء QR جماعي",
    IMAGE_CREATION_TOKEN: "توكن إنشاء الصور",
    CATEGORIES: "التصنيفات",
    CREATE_DEFAULT_PRODUCT: "إنشاء منتج افتراضي",
    DOMAINS: "النطاقات",
    REMINDERS: "التذكيرات",
    AUTOMATIC_CREATION: "إنشاء تلقائي",
    SEND_ADMIN_SMS: "إرسال رسالة أدمن",
    UNCREATED_CARDS: "بطاقات غير منشأة",
    MODELS_LIST: "قائمة النماذج",
    UPLOAD_CENTER: "مركز الرفع",
    INFORMATION_REGISTRATION: "تسجيل المعلومات",
    TARIFFS: "التعرفات",
    REGISTERED_INFO_LIST: "قائمة المعلومات المسجلة",
    //code
    personel: "الموظفون",
    "workReports/create": "تقرير عمل",
    "admin/user-guide": "دليل المستخدم",
    phonebook: "نادي العملاء",
    contactlist: "مساعد الاتصال (شكر على الاتصال)",
    "contact/list": "مساعد الاتصال (شكر على الاتصال)",
    "admin/transferRequests": "طلبات السحب",
    "admin/wallet": "محفظة جديدة",
    "admin/cdr": "مراقبة الاتصال",
    "admin/campaign": "الحملة",
    "admin/message-categories": "تصنيف الرسائل",
    "admin/customers": "CRM العملاء",
    "admin/notifications": "إشعارات الأدمن",
    "admin/user-history/notifications": "إشعارات سجل المستخدمين",
    "admin/messages": "الرسائل",
    profile: "الملف الشخصي",
    "admin/workReports": "إدارة تقارير العمل",
    panel: "شراء لوحة",
    adminDiscounts: "الخصومات",
    departments: "الأقسام",
    adminTickets: "إدارة التذاكر",
    "admin/configs": "الإعدادات",
    notifications: "الإشعارات",
    "user/confirmed": "طلبات المستخدمين",
    users: "قائمة المستخدمين",
    payments: "بوابة الدفع",
    permission: "الصلاحيات",
    panels: "اللوحات",
    category: "القوائم",
    content: "المحتوى",
    role: "الأدوار",
    "core/admin": "إدارة الأساس",
    //robot
    numberList: "قائمة أرقامي",
    registerAd: "تسجيل إعلان",
    proPanelSendAd: "إرسال إعلان لوحة احترافية",
    buyCharge: "شراء شحن",
    scheduledAdSend: "إرسال إعلان مجدول",
    smartGradual: "ذكي/تدريجي",
    createNumberTariff: "إنشاء تعرفة الأرقام",
    numberTariffList: "قائمة تعرفة الأرقام",
    otherTariffList: "قائمة تعرفات أخرى",
    userNumbers: "أرقام المستخدمين",
    numbers: "الأرقام",
    management: "إدارة",
    settings: "الإعدادات",
    registerUserNumber: "تسجيل رقم للمستخدم",
    divarPayments: "دفعات ديوار",
    autoPayment: "دفع تلقائي",
    adAnalyzer: "محلل زيارة الإعلان",
    infoReview: "مراجعة المعلومات",
    rb_payments: "الدفعات",
    autoChat: "دردشة آلية",
    ads: "الإعلانات",
    monitoring: "مراقبة",
    smartLadder: "سلم ذكي",
    gradualLadder: "سلم تدريجي",
    excelFiles: "ملفات إكسل",
    autoChats: "دردشة ذكية",
    addAdPhoto: "إضافة صورة إعلان",
    targetTools: "أدوات مستهدفة",
    smartList: "قائمة ذكية/تدريجية",
    scheduledAdList: "قائمة الإعلانات المجدولة",
    adsList: "قائمة الإعلانات",
    adReports: "تقارير الإعلان",
    personalAdSend: "إرسال إعلان شخصي",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "أدخل الوقت المطلوب:",
    SUBTITLE:
      "بعد تحديد الوقت، ستتم إعادة تحميل هذه الصفحة دائماً في الوقت المحدد.",
    TIME_LABEL: "الوقت",
  },
  MODAL: {
    OK_TITLE: "تأكيد",
  },

  ROUTE: {
    TITLES: {
      QR_LUCK_WHEEL_Edit: "تعديل دولاب الحظ",
      QR_LUCK_WHEEL: "سوي كود QR لدريشة الحظ",
      DASHBOARD: "لوحة التحكم",
      ADMIN_QR_DOMAINS: "مراقبة النطاقات",
      ADMIN_TOGETHER_TOKEN: "مراقبة التوكنات",
      ADMIN_QR_SMS: "إرسال رسائل",
      MENU_PROFILE_INFO: "معلومات المستخدم",
      MENU_PROFILE_SETTING: "إعدادات الملف الشخصي",
      MENU_PROFILE_ORDERS: "الطلبات",
      MENU_PROFILE_ADDRESSES: "العناوين",
      QR_MONITORING: "مراقبة QR",
      QR_LIST: "قائمة QR الخاصة بي",
      QR_NAME_LIST: "إدارة المشاركة",
      QR_GENERATE_MULTIPLE: "إنشاء QR جماعي",
      QR_CARD_VISIT: "إنشاء بطاقة زيارة",
      HELP_INFO: "اختبار الزر",
      QR_MENU: "قائمة متجر",
      QR_APPOINTMENT: "حجز موعد",
      QR_INSURANCE: "إنشاء تأمين عبر الإنترنت",
      QR_BPAGE: "إنشاء صفحة عمل",
      QR_CPAGE: "إنشاء موقع مجمع تجاري/إداري",
      QR_BSHOP: "متجر عبر الإنترنت",
      QR_NAME_EDIT_BSHOP: "تعديل المتجر عبر الإنترنت",
      QR_LINK_EDIT: "تعديل الرابط",
      QR_NAME_DESIGN: "تعديل التصميم",
      QR_NAME_SETTING: "تعديل الإعدادات",
      QR_NAME_EDIT: "تعديل بطاقة الزيارة",
      QR_NAME_EDIT_BPAGE: "تعديل صفحة العمل",
      QR_EDIT_CPAGE: "تعديل موقع المجمع التجاري/الإداري",
      QR_NAME_INSURANCE: "تعديل التأمين عبر الإنترنت",
      QR_NAME_EDIT_MENU: "تعديل القائمة",
      QR_NAME_EDIT_APPLICATION: "تقديم التطبيق",
      QR_NAME_EDIT_APPOINTMENT: "تعديل حجز الموعد",
      QR_NAME_EDIT_PHOTO: "تعديل معرض الصور",
      QR_NAME_EDIT_VIDEO: "تعديل معرض الفيديو",
      QR_NAME_EDIT_VOICE: "تعديل معرض الصوت",
      QR_NAME_EDIT_FEEDBACK: "تعديل معرض التعليقات",
      QR_NAME_CONSULTATION_QR_EDIT: "تعديل نموذج الطلب",
      QR_NAME_EDIT_VOICE_PRO: "تعديل معرض الصوت (برو)",
      QR_NAME_EDIT_SOCIAL: "تعديل الشبكات الاجتماعية",
      QR_NAME_STATISTICS: "إحصائيات رمز QR",
      QR_CATE: "اختيار الفئة",
      QR_SHARE: "مشاركة",
      QR_BUSINESS_SHOP: "أعمال/متجر",
      QR_CO_ORGAN: "شركة/منظمة",
      QR_CONTACT: "الاتصال بالعميل",
      QR_NOTICES: "إشعارات",
      QR_OTHERS: "متنوع",
      QR_STATICS: "QR ثابت",
      QR_DYNAMICS: "QR ديناميكي",
      QR_D_BUSINESS: "QR ديناميكي أعمال",
      QR_D_ORGANS: "QR ديناميكي منظمات",
      QR_D_GOVERNMENT: "QR ديناميكي حكومي",
      QR_VIDEO: "معرض فيديو",
      QR_APPLICATION: "تقديم التطبيق",
      QR_VOICE: "معرض صوت",
      QR_VOICE_PRO: "معرض صوت (برو)",
      QR_CONSULTATION_QR: "نموذج طلب",
      QR_FEEDBACK: "معرض تعليقات",
      QR_PHOTO: "معرض صور",
      QR_CATALOG: "كتالوج / بروشور",
      QR_LOCATION: "إنشاء QR موقع",
      QR_SOCIAL_MEDIA: "إنشاء QR شبكة اجتماعية",
      QR_LINK: "إنشاء رابط",
      QR_TEXT: "إنشاء نص",
      QR_MAIL: "إنشاء بريد إلكتروني",
      QR_CALL: "اتصال",
      QR_SMS: "رسالة",
      QR_WHATSAPP: "واتساب",
      QR_SITE: "موقع إلكتروني",
      QR_INSTAGRAM: "إنستغرام",
      QR_SKYPE: "سكايب",
      QR_WIFI: "واي فاي",
      QR_BUSINESS: "صفحة عمل",
      QR_DISCOUNT: "صفحة خصم",
      QR_PRODUCT_SHOP: "تقديم المنتج",
      QR_PRODUCT_LABEL: "ليبل المنتج",
      QR_GOLD_LABEL: "ليبل الذهب",
      QR_PRODUCT_TEMPLATE: "المنتجات",
      ADMIN_CATEGORY: "التصنيفات",
      QR_NFC_ORDERS: "بطاقات NFC في انتظار التأكيد",
      QR_NAME_PRODUCT: "تعديل تقديم المنتج",
      QR_NAME_LABELPRODUCT: "تعديل ليبل المنتج",
      QR_NAME_GOLDPRODUCT: "تعديل ليبل الذهب",
      QR_COINS: "العملات الرقمية",
      QR_SHOP: "إدارة المتجر",
      QR_TWITTER: "تويتر",
      UPLOAD_CENTER: "مركز الرفع",
      PRICING: "تعرفة QR",
      QR_CREATE_MODELS: "إنشاء نموذج بطاقة زيارة",
      QR_CREATE_BUSINESS_MODELS: "إنشاء نموذج صفحة عمل",
      QR_CREATE_PRODUCT_MODEL: "إنشاء نموذج بطاقة منتج",
      QR_CREATE_MENU_MODELS: "إنشاء نموذج قائمة متجر",
      QR_CREATE_SHOP_MODEL: "إنشاء نموذج متجر عبر الإنترنت",
      MODELS_LIST: "أنواع نماذج QR",
      MODELS_LIST_EDIT: "تعديل النموذج",
      MODELS_LIST_MENU_EDIT: "تعديل نموذج القائمة",
      MODELS_LIST_BMODEL_EDIT: "تعديل نموذج المتجر عبر الإنترنت",
      NFC: "بطاقات NFC",
      SUBMIT_FORM: "تسجيل بلوغر",
      REQUEST_LIST: "قائمة البلوغرز",
      PURE_DATA: "قائمة بطاقات الزيارة غير المنشأة",
      AUTO_CREATE: "إنشاء QR تلقائي",
      QR_CREATE: "إنشاء QR",
      HISTORY_REMINDER: "مراقبة التذكير",
      BOOK: "مراقبة التذكير",
    },
  },
  qr_management: "إدارة QR",
  router: {
    dashboard: "لوحة التحكم",
    contacts: "نادي العملاء",
    editContact: "تعديل العميل",
    createContact: "إنشاء عميل",
    customers: "قائمة العملاء",
    contactList: "مساعد الاتصال",
    messages: "الرسائل",
    messageCategories: "تصنيف الرسائل",
    oldTransactions: "المعاملات القديمة",
    yourTransactions: "معاملاتك",
    buyPanel: "شراء لوحة",
    permissions: "الصلاحيات",
    createPermission: "إنشاء صلاحية",
    invitations: "قائمة دعواتي",
    editUser: "تعديل المستخدم",
    userInformation: "عرض معلومات المستخدم",
    walletEdit: "تعديل معلومات محفظة المستخدم",
    userHistory: "سجل المستخدم",
    userNotificationsHistory: "سجل إشعارات المستخدمين",
    notifications: "الإشعارات",
    createNotification: "إنشاء إشعار",
    editNotification: "تعديل الإشعار",
    adminNotifications: "إشعارات الأدمن",
    yourNotifications: "إشعاراتك",
    adminNotificationsList: "إشعارات المدير",
    tickets: "التذاكر",
    createTicket: "تسجيل تذكرة جديدة",
    editTicket: "تعديل التذكرة",
    departments: "الأقسام",
    createDepartment: "قسم جديد",
    editDepartment: "تعديل القسم",
    adminTickets: "إدارة التذاكر",
    discounts: "الخصومات",
    createDiscount: "إنشاء خصم",
    editDiscount: "تعديل الخصم",
    workReports: "تقرير العمل",
    createWorkReport: "إنشاء تقرير عمل",
    callMonitoring: "مراقبة الاتصال",
    adminWorkReports: "إدارة تقارير العمل",
    editWorkReport: "عرض وتعديل تقرير العمل",
    packProperties: "خصائص الحزمة",
    createPackProperty: "إنشاء خاصية حزمة",
    editPackProperty: "تعديل خاصية الحزمة",
    panels: "اللوحات",
    createPanel: "إنشاء لوحة",
    editPanel: "تعديل اللوحة",
    transferRequests: "طلبات السحب",
    editTransferRequest: "تعديل طلب السحب",
    tariffs: "التعرفات",
    createTariff: "إنشاء تعرفة",
    editTariff: "تعديل التعرفة",
    requests: "الطلبات",
    viewUser: "عرض المستخدم",
    manageTransactions: "إدارة المعاملات",
    viewTransaction: "عرض المعاملة",
    manageConfigs: "إدارة الإعدادات",
    rbLandConfigs: "إدارة إعدادات روبوت لاند",
    editConfig: "تعديل الإعدادات",
    manageUsers: "إدارة المستخدمين",
    categories: "التصنيفات",
    createCategory: "إضافة تصنيف",
    editCategory: "تعديل التصنيف",
    content: "المحتوى",
    createContent: "إدراج محتوى",
    editContent: "تعديل المحتوى",
    addUserGuide: "إضافة دليل المستخدم",
    editUserGuide: "تعديل دليل المستخدم",
    roles: "الأدوار",
    editRole: "تعديل الدور",
    createRole: "إضافة دور",
    permissionTitle: "الصلاحيات", // لـ cruds.permission.title
    paymentGateways: "بوابات الدفع",
    editPaymentGateway: "تعديل بوابات الدفع",
    campaigns: "الحملات",
    createCampaign: "إنشاء حملة",
    editCampaign: "تعديل معلومات الحملة",
    adminCustomers: "العملاء",
    createCustomer: "إنشاء عملاء",
    editCustomerInfo: "تعديل معلومات العميل",
    referrerCustomers: "العملاء المعرفون",
    customerHistory: "سجل العميل",
    userProfile: "الملف الشخصي للمستخدم",
    editProfile: "تعديل الملف الشخصي",
    inviteFriends: "دعوة الأصدقاء",
    personalInfo: "المعلومات الشخصية",
    editPersonalInfo: "تعديل المعلومات",
    changePassword: "تغيير كلمة المرور",
    newWallet: "محفظة جديدة",
  },
  ticket: {
    text: "تسجيل تذكرة",
  },
};
